module.exports = __webpack_public_path__ + "static/media/gold-special.db195c7f.svg";